module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg4-fd6931f5ac09e473e285c005a07c838f.jpg";